import { RegularButton } from 'pg-ui-library';
import { ReactComponent as PI } from 'src/assets/previous_default.svg';
import { ReactComponent as NI } from 'src/assets/next_default.svg';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-right: 25px;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;
  margin: 0;
  text-align: center;
`;

export const CloseIcon = styled.img`
  height: auto;
  width: 14px;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  margin-right: 30px;
`;
export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow-x: scroll;
  height: 410px;
  width: 100%;
  justify-content: center;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 0;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 0;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`;

export const FormButton = styled(RegularButton)`
  min-width: 82px;
  a {
    color: #fff;
    text-decoration: none;
  }
`;

export const PreviousIcon = styled(PI)`
  position: absolute;
  left: 5%;
  cursor: pointer;
  height: 30px;
  align-self: center;
  transition: fill 0.2s ease-in-out;
  z-index: 1;
`;

export const NextIcon = styled(NI)`
  position: absolute;
  right: 5%;
  cursor: pointer;
  height: 30px;
  align-self: center;
  transition: fill 0.2s ease-in-out;
  z-index: 1;
`;

export const SmokerOptionAlert = styled.p`
  margin: 7px;
  color: red;
  font-size: 16px;
`;
